// zh_cn:
// linear-gradient(135deg,#fe0,#ffd200) #000
// en_us:
// linear-gradient(315deg,#25272a,#4b4c50) #fe0
// linear-gradient(135deg,#ff4451,#e20010) #fff
import { Commodity } from '@/types/product';

export const LabelStyle = {
  red: {
    backGroundColor: '#FD6651',
    fontColor: '#FFFFFF',
  }, // LimitedOffer限时折扣颜色
  yellow: {
    backGroundColor: 'linear-gradient(91.03deg, #FFE901 6.76%, #FFD301 99.57%);',
    fontColor: '#302802',
  }, // 推荐标签色
  gray: {
    backGroundColor: '#AFB1B4',
    fontColor: '#FFF',
  }, // 无库存标签
  save: {
    backGroundColor: '#FFE2E2',
    fontColor: '#FF4040',
  }, // 新版减价
  prime: {
    backGroundColor: '#EEF7FF',
    fontColor: '#1A98FF',
  }, // Prime标签
} as const;

// 前端配置标签仅有限时折扣、无库存，其他全部标签在运营后台配置。
export const getLABEL = (LANG: LANG) => {
  const allLabels = {
    bestValue: {
      // 人气推荐
      tagContent: LANG['common.label.tagBestValue'],
      tagName: 'bestValue',
      index: 0,
    },
    popular: {
      // 热销中
      tagContent: LANG['common.label.tagPopular'],
      tagName: 'popular',
      index: 0,
    },
    premium: {
      // 顶配版
      tagContent: LANG['common.label.tagPremium'],
      tagName: 'premium',
      index: 0,
    },
    ultimatedPair: {
      // 极致之选
      tagContent: LANG['common.label.tagUltimatedPair'],
      tagName: 'ultimatedPair',
      index: 0,
    },
    limitedOffer: {
      // 限时优惠
      tagContent: LANG['common.label.tagLimitedOffer'],
      tagName: 'limitedOffer',
      ...LabelStyle.red,
      index: 1,
    },
    savePrice: {
      // save减价标签
      tagContent: LANG['productNew.label.save_price'],
      tagName: 'savePrice',
      ...LabelStyle.save,
      index: 1,
    },
    campaignServicelimitedOffer: {
      // EOSS 增值服务的限时优惠
      tagContent: LANG['common.label.productNew.label.save_price'],
      tagName: 'campaign_tagLimitedOffer',
      ...LabelStyle.red,
      index: 1,
    },
    limitedEdition: {
      // 限定版
      tagContent: LANG['common.label.tagLimitedEdition'],
      tagName: 'limitedEdition',
      ...LabelStyle.red,
      index: 1,
    },
    deal: {
      // 优惠
      tagContent: LANG['common.label.tagDeal'],
      tagName: 'deal',
      ...LabelStyle.red,
      index: 2,
    },
    ActionEssentials: {
      // 运动必备
      tagContent: LANG['common.label.tag_ActionEssentials'],
      tagName: 'ActionEssentials',
      index: 3,
    },
    new: {
      // 新品
      tagContent: LANG['common.label.tagNew'],
      tagName: 'new',
      ...LabelStyle.red,
      index: 3,
    },
    GO3_32G: {
      tagContent: LANG['product.go3.32G_version_tag'],
      tagName: 'GO3-32G',
      index: 0,
    },
    GO3_64G: {
      // 人气推荐
      tagContent: LANG['product.go3.64G_version_tag'],
      tagName: 'GO3-64G',
      index: 0,
    },
    GO3_128G: {
      // 人气推荐
      tagContent: LANG['product.go3.128G_version_tag'],
      tagName: 'GO3-128G',
      index: 0,
    },
    noRedNewVersion: {
      tagContent: LANG['common.label.go3_black_version_tag'],
      tagName: 'noRedVersion',
      index: 0,
    },
    newVersion: {
      // 全新
      tagContent: LANG['common.label.tagNewVersion'],
      tagName: 'newVersion',
      ...LabelStyle.red,
      index: 3,
    },
    ace: {
      tagContent: LANG['product.IAC1.version_tag'],
      tagName: 'ace_version_title',
    },
    acePro: {
      tagContent: LANG['product.Ace.pro_version_tag'],
      tagName: 'pro_version_tag',
    },
    outOfStock: {
      // 无库存
      tagContent: LANG['product.sale_state.out_of_stock'],
      tagName: 'outOfStock',
      ...LabelStyle.gray,
    },
  } as const;

  return allLabels;
};

export const getCommodityItemLabel = ({ LANG }: { LANG: LANG }) => {
  return getLABEL(LANG);
};

function showLabel(LANG: LANG, commodity: Commodity) {
  const labels = [];
  const LABEL = getLABEL(LANG);
  if ([1074].includes(commodity.id)) {
    labels.push(LABEL.bestValue); // 性价比之选
  }
  if ([1315].includes(commodity.id)) {
    labels.push(LABEL.new); // 新品
  }

  return labels;
}

export default {
  getCommodityItemLabel,
  showLabel,
  LabelStyle,
};
